module.exports = __webpack_public_path__ + "14_hair_silver.ec0d28c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/14_hair_silver.png
// module id = peYg
// module chunks = 0